module.exports = __webpack_public_path__ + "img/faq1.5927fb3f.png";